import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Render the final JSX of CardHeader.
 */
export const renderCardHeader_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/_jsxs(state.root, {
    children: [state.image && /*#__PURE__*/_jsx(state.image, {}), state.header && /*#__PURE__*/_jsx(state.header, {}), state.description && /*#__PURE__*/_jsx(state.description, {}), state.action && /*#__PURE__*/_jsx(state.action, {})]
  });
};